"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _report = require("@/api/report");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _moment = _interopRequireDefault(require("moment"));
var ReportWeek = /*#__PURE__*/function (_Vue) {
  function ReportWeek() {
    var _this;
    (0, _classCallCheck2.default)(this, ReportWeek);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ReportWeek, [].concat(args));
    (0, _defineProperty2.default)(_this, "date", void 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "query", {
      date: (0, _moment.default)().startOf("week").add(1, "d").format("YYYY-MM-DD")
    });
    (0, _defineProperty2.default)(_this, "filters", {});
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    return _this;
  }
  (0, _inherits2.default)(ReportWeek, _Vue);
  return (0, _createClass2.default)(ReportWeek, [{
    key: "watchDate",
    value: function watchDate(data) {
      if (data) {
        this.query.date = data;
        this.fetchData();
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
  }, {
    key: "handleDetail",
    value: function handleDetail(row) {
      this.$emit("load:date", (0, _moment.default)(row.date, "DD/MM/YYYY").format("YYYY-MM-DD"));
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      this.loading = true;
      _report.reportApi.week((0, _objectSpread2.default)({}, this.query)).then(function (res) {
        _this2.data = res.data;
      }).finally(function () {
        return _this2.loading = false;
      });
    }
  }, {
    key: "getSummaries",
    value: function getSummaries(_ref) {
      var data = _ref.data;
      var sum = [];
      sum[0] = "Total";
      sum[3] = 0; // origin
      sum[4] = 0; // total price
      sum[5] = 0; // profit
      data.forEach(function (element) {
        sum[3] += +element.sumOrigin;
        sum[4] += +element.sumReal;
        sum[5] += element.sumProfit;
      });
      sum[3] = this.$formatNumberVN(sum[3]) + "đ";
      sum[4] = this.$formatNumberVN(sum[4]) + "đ";
      sum[5] = this.$formatNumberVN(sum[5]) + "đ";
      return sum;
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], ReportWeek.prototype, "date", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  immediate: true
})], ReportWeek.prototype, "watchDate", null);
ReportWeek = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], ReportWeek);
var _default = exports.default = ReportWeek;